const EbConstants = {
    EbIntegrationId: "amazon-eventbridge-source",
    EbAwsAccountIds: ["640005036677", "387624331742", "572734708359", "543357402162"], // This can be moved to dynamodb
    EBAwsLegacyProdAccountId: "543357402162",
    EBAwsComplianceAccountId: "387624331742",
    EBAwsDevAccountId: "640005036677",
    EBAwsDemoAccountId: "572734708359",
    EbHistoricalEvents: [
        "v2.detail.events.conversation.{id}.attributes", 
        "v2.analytics.conversation.{id}.metrics", 
        "v2.flows.instances.flow.{id}", 
        "v2.conversations.{id}.transcription", 
        "v2.audits.entitytype.{id}.entityid.{id}",
        "v2.bot.conversation.{id}.conversations.summaries",
        "v2.users.{id}.conversations.summaries",
        "v2.speechandtextanalytics.conversation.{id}.empathy",
        "v2.speechandtextanalytics.conversation.{id}.sentiment",
        "v2.speechandtextanalytics.conversation.{id}.topics",
        "v2.speechandtextanalytics.conversations.{id}.categories",
        "v2.conversations.{id}.agentchecklist"
    ], // This can be moved to dynamodb
    EbDIEvents: [
        "v2.analytics.conversation.{id}.metrics",
        "v2.analytics.flow.{id}.metrics",
        "v2.analytics.queues.{id}.observations",
        "v2.detail.events.conversation.{id}.acd.end",
        "v2.detail.events.conversation.{id}.acd.start",
        "v2.detail.events.conversation.{id}.acw",
        "v2.detail.events.conversation.{id}.attributes",
        "v2.detail.events.conversation.{id}.customer.end",
        "v2.detail.events.conversation.{id}.customer.start",
        "v2.detail.events.conversation.{id}.flow.end",
        "v2.detail.events.conversation.{id}.flow.start",
        "v2.detail.events.conversation.{id}.user.end",
        "v2.detail.events.conversation.{id}.user.start",
        "v2.detail.events.conversation.{id}.wrapup",
        "v2.flows.outcomes.{id}",
        "v2.users.{id}.presence",
        "v2.users.{id}.routingStatus",
        "v2.taskmanagement.workitems.{id}",
        "v2.taskmanagement.workitems.queues.{id}",
        "v2.bot.conversation.{id}.conversations.summaries",
        "v2.users.{id}.conversations.summaries",
        "v2.flows.instances.flow.{id}",
        "v2.speechandtextanalytics.conversation.{id}.empathy",
        "v2.speechandtextanalytics.conversation.{id}.sentiment",
        "v2.speechandtextanalytics.conversation.{id}.topics",
        "v2.speechandtextanalytics.conversations.{id}.categories",
        "v2.conversations.{id}.agentchecklist"
    ], // This can be moved to dynamodb
    EbCreationAwsAccountId: ["640005036677", "387624331742"], // AWS accounts used while creating a new a3s dev and prod eb.
    EbCreationEventSourceSuffix: ["a3s-dev", "a3s-prod"],
    EbCreationIntegrationName: ["A3S Analytics - Event Sources For - dev", "A3S Analytics - Event Sources For - prod"],
    A3SHistoricalProductId: "e39dbb94-3cec-4a1a-b733-d7d18387eac7"
}

export default EbConstants;